import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router';
import Store from '../Store/Store';
import Request from '../Request/Request';
import { cap } from '../utilities/utilities';
import Logo from './Logo';

export default function Menu( props ) {

	const navigate = useNavigate()
	const tabs = props.tabs

	return <div style={{ display:'flex', alignItems:'center' }} >

		{ props.setRowId && 
			<div onClick={ e => props.setRowId( true ) }
				className="material-symbols-outlined"
				style={{ 
					background:'#ddd', fontSize:30, cursor:'pointer', 
					padding:6, margin:'0 0 0 20px', borderRadius:'50%', 
				}}
			>
				add
			</div>
		}

		<table style={{ margin:20, fontSize:13 }} ><tbody><tr>
		{ tabs && tabs.length > 0 && tabs.map( ( a, i ) => (
			<td key={ a[ props.tabKey ] }
				style={{ 
					cursor:'pointer', whiteSpace:'pre', 
					fontWeight:600, padding:'8px 16px',
					color:a[ props.tabKey ] === props.tab ? '#fff' : '#000',
					background:a[ props.tabKey ] === props.tab ? '#000' : '#fff',

				}} 
				onClick={ e => { 
					props.setTab( a[ props.tabKey ] ) 
					props.setRowId && props.setRowId( false ) 
				} } 
			>
				{ cap( a[ props.tabLabel ] ) }
			</td>
		) ) }
		</tr></tbody></table>

		<div style={{ flexGrow:9999 }} />
		<Dropdown updateContent={ props.updateContent } />

	</div>
}


function Dropdown( props ) {

	const navigate = useNavigate()
	const [ visible, setVisible ] = useState( false )

	const signOut = e => { 
		Request.get( 'expire', 
			d => {
				Store.set( 'user', null )
				Store.clear()
				navigate('/')
			},  
			e => {
				console.error( e.message )
				Store.set( 'user', null )
				Store.clear()
				navigate('/')
			},  
		)
	}

	const website = e => {
		props.updateContent()
		navigate('/')
	}

	return <>
		{ visible && <>
			<div 
				className="menu-bg-intro"
				style={{ 
					position:'fixed', left:0, top:0, zIndex:9, 
					width:'100%', height:'100%', cursor:'pointer', 
					background:'#000', opacity:0.333 
				}} 
				onClick={ e => setVisible( false ) }
			/>
			<div 
				className="menu-intro"
				style={{
					position:'fixed', top:0, width:200, height:'100%', 
					zIndex:10, boxSizing:'border-box', background:'white',
					padding:'70px 0 20px 0', boxShadow:'0 0 32px #00000044', 
					fontWeight:600, fontSize:18, lineHeight:3, userSelect:'none', 
					transition:'',
				}} 
			>
				<LinkItem icon="public" label="Website" onClick={ website } setVisible={ setVisible } />
				<LinkItem icon="directions_boat" label="Cruises" path="/cruises-update" setVisible={ setVisible } />
				<LinkItem icon="shopping_basket" label="Bookings" path="/bookings-update" setVisible={ setVisible } />
				<LinkItem icon="auto_stories" label="Pages" path="/pages-update" setVisible={ setVisible } />
				{/* <LinkItem icon="lists" label="Pages Order" path="/pages-order" setVisible={ setVisible } /> */}
				<LinkItem icon="settings" label="Database" path="/admin" setVisible={ setVisible } />
				<LinkItem icon="logout" label="Sign Out" onClick={ signOut } setVisible={ setVisible } />
			</div>
		</> }
		<div 
			onClick={ e => setVisible( !visible ) } 
			className="material-symbols-outlined"
			style={{ 
				position:visible ? 'fixed' : 'fixed', background:'#fff', 
				top:10, right:0, fontSize:30, cursor:'pointer', 
				padding:'12px 18px 12px 12px', userSelect:'none', zIndex:11,
				boxShadow:'0 0 12px #fff', borderRadius:'27px 0 0 27px', 
			}}
		>
			{ visible ? 'close' : 'menu' }
		</div>
	</>
}

function LinkItem( props ) {

	const location = useLocation()
	const path = location.pathname
	const navigate = useNavigate()

	const onClick = e => {
		if ( props.path ) {
			props.setVisible( false )
			navigate( props.path )
		} else {
			props.setVisible( false )
			props.onClick( e )
		}
	}

	return (
		<div 
			onClick={ onClick } 
			className={ props.path === path ? 'menu-item-active' : 'menu-item' }
			style={{ 
				display:'flex', alignItems:'center', justifyContent:'flex-end', 
				height:60, margin:0, paddingRight:10, cursor:'pointer',  
			}} 
		>
			<div style={{ fontWeight:600, fontSize:13, whiteSpace:'nowrap', ...props.style }} >
				{ props.label }
			</div>
			<div 
				className="material-symbols-outlined"
				style={{ fontSize:30, padding:'5px 10px 5px 5px' }}
			>
				{ props.icon }
			</div>
		</div>
	)
}
